import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

interface DuplicateCampaignPayload {
  campaign_id: number;
  payload: {
    campaign_name: string;
    campaign_app_package_id: string;
    campaign_end_date: string;
    campaign_budget: number;
    campaign_country: string[];
    campaign_bidding_strategy: string;
    campaign_target_cpa: number;
    campaign_target_roas: number;
  };
}

export const useCampaignCreate = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, DuplicateCampaignPayload>({
    mutationFn: async ({ campaign_id, payload }) => {
      await httpService.post(
        `${API_CONFIG.path.campaigns}/${campaign_id}/copy`,
        payload
      );
    },
    onSuccess: () => {
      // Invalidate the campaigns query to trigger a refetch
      queryClient.invalidateQueries({ queryKey: ["campaigns"] });
    },
  });
};
